export enum AdminProjectsTabEnum {
    active = 1,
    locked = 2,
    favorite = 0
}
